import React, { useState, useEffect } from "react";

import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Trans } from "react-i18next";
import CloseIcon from "@material-ui/icons/Close";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import IconButton from "@material-ui/core/IconButton";
import { ClickAwayListener } from "@material-ui/core";
import ItemNotification from "../list-item/ItemNotification";
import List from "@material-ui/core/List";
import Popper from "@material-ui/core/Popper";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import Tooltip from "@material-ui/core/Tooltip";
import { stompClientsContainer} from "../../UniversalElement";
import { notificationClient } from "../../AxiosClient";
import Pagination from "@material-ui/lab/Pagination";
import CircularProgress from "@material-ui/core/CircularProgress";
const useStyles = makeStyles((theme) => ({
  popper: {
    zIndex: 1299,
    boxShadow:
      "0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)",
    marginTop: 7,
    maxWidth: "80%",
    maxHeight: "75%",
    overflowX: "hidden",
    overflowY: "auto",
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: "-0.9em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: `transparent transparent ${
          theme.palette.background.paper
        } transparent`,
      },
    },
  },
  arrow: {
    position: "absolute",
    fontSize: 7,
    width: "3em",
    height: "3em",
    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  paper: {
    width: 400,
  },
  emptyText: {
    textAlign: "center",
    marginBottom: 15,
  },
  tooltip: {
    zIndex: 9999999999999999999,
  },
}));

function NotificationDialog(props) {
  const [arrowRef, setArrowRef] = useState(null);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [onlyUnread, setOnlyUnread] = useState(true);
  const [notifications, setNotifications] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(5);
  const classes = useStyles();
  const { t } = useTranslation();

  const onClickAway = () => {
    if (isEditOpen) {
      return;
    }
    props.onClose();
  };

  const clearAll = () => {
    stompClientsContainer.notificationservice.publish({ destination: "/app/notification/delete/all" });
  };

  const readAll = () => {
    stompClientsContainer.notificationservice.publish({ destination: "/app/notification/read/all" });
  };

  const toggleFilter = () => {
    setOnlyUnread(!onlyUnread);
  };

  const getNotifications = () =>{
    setLoading(true);
    notificationClient
      .post(`/notification`,{page:page - 1,size:size, onlyUnread:onlyUnread}, { withCredentials: true })
      .then((res) => {
        setLoading(false);
        setNotifications(res.data.content);
      });
  }

  const handleChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
   if (!notifications){
    getNotifications();
   }
  }, []);

  useEffect(() => {
     getNotifications();
   }, [props.updateNotifications]);

  useEffect(() => {
     getNotifications();
   }, [page, onlyUnread]);

  return (
    <div>
      <ClickAwayListener onClickAway={onClickAway}>
        <Popper
          open={props.open}
          anchorEl={props.anchorEl}
          placement="bottom"
          className={classes.popper}
          modifiers={{
            flip: {
              enabled: false,
            },
            arrow: {
              enabled: true,
              element: arrowRef,
            },
            preventOverflow: {
              enabled: true,
              boundariesElement: "scrollParent",
            },
          }}
        >
          <span className={classes.arrow} ref={(node) => setArrowRef(node)} />
          <Paper
            className={classes.paper}
            elevation={24}
            id="notifications-dialog"
          >
            <DialogTitle>
              <Trans i18nKey="global_notification_plural" />
              <div className={classes.closeButton}>
                <Tooltip
                  title={
                    onlyUnread
                      ? t("notifications_filter_all")
                      : t("notifications_filter_only_unread")
                  }
                  classes={{ popper: classes.tooltip }}
                >
                  <IconButton aria-label="Toggle Filter" onClick={toggleFilter}>
                    {onlyUnread ? (
                      <NotificationsActiveIcon />
                    ) : (
                      <NotificationsNoneIcon />
                    )}
                  </IconButton>
                </Tooltip>
                <Tooltip
                  title={t("notifications_mark_all_read")}
                  classes={{ popper: classes.tooltip }}
                >
                  <IconButton aria-label="Close" onClick={readAll}>
                    <DoneAllIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  title={t("global_close")}
                  classes={{ popper: classes.tooltip }}
                >
                  <IconButton
                    aria-label="Close notifications"
                    onClick={props.onClose}
                    autoFocus
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
            <DialogContent>
              {loading ? <div style={{ display: "flex", flexDirection: "column", alignItems: "center", margin: "5px auto",}}> <CircularProgress/> </div>:
              notifications && notifications.length > 0 ? (
                <>
                  <List>
                    {notifications.map((element, idx) => {
                      return (
                        <div role="listitem">
                          <ItemNotification
                            key={element.messageId}
                            data={element}
                            onClose={onClickAway}
                            onEdit={(isEditOpen) => setIsEditOpen(isEditOpen)}
                          />
                          <Divider variant="middle" component="li" />
                        </div>
                      );
                    })}
                  </List>
                  <div style={{display: "flex"}}>
                    <Pagination
                      style={{ marginLeft: "auto",marginRight: "auto",display: "flex"}}
                      size="small"
                      showFirstButton
                      showLastButton
                      count={!onlyUnread ? Math.ceil(props.userTotalMessages/size) : Math.ceil(props.userUnreadMessages/size)}
                      page={page}
                      onChange={handleChange}
                    />
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <Button onClick={clearAll}>
                      {t("notifications_clear_all")}
                    </Button>
                  </div>
                </>
              ) :notifications && notifications.length ==0 ? (
                <Typography className={classes.emptyText}>
                  <Trans i18nKey="no_new_notifications" />
                </Typography>
              ):(
                <div></div>
              )}
            </DialogContent>
          </Paper>
        </Popper>
      </ClickAwayListener>
    </div>
  );
}

export default NotificationDialog;
